import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleryService } from '../../services/gallery';

interface GalleryImage {
  id: number;
  title: string;
  imageUrl: string;
  sortOrder: number;
}

@Component({
  selector: 'app-gallery-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './gallery.html',
  styleUrl: './gallery.scss'
})
export class GalleryPage implements OnInit {

  images: GalleryImage[] = [];

  selectedIndex = -1;

  constructor(
    private galleryService: GalleryService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {

    this.galleryService.getImages().subscribe({

      next: (data: GalleryImage[]) => {

        console.log('Gallery images:', data);

        this.images = data.sort(
          (a, b) => a.sortOrder - b.sortOrder
        );

        console.log('Loaded images:', this.images.length);

        this.cdr.detectChanges();

      },

      error: (err) => {

        console.error('Error loading gallery:', err);

      }

    });

  }

  open(index: number) {
    this.selectedIndex = index;
  }

  close() {
    this.selectedIndex = -1;
  }

  next() {

    if (this.selectedIndex < this.images.length - 1) {
      this.selectedIndex++;
    }

  }

  previous() {

    if (this.selectedIndex > 0) {
      this.selectedIndex--;
    }

  }

}